export interface CategoryInfo {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const allCategories: CategoryInfo[] = [
  { slug: 'remen', name: '热门连载', icon: 'ri-fire-line', count: 1280 },
  { slug: 'zuixin', name: '最新上架', icon: 'ri-rocket-line', count: 356 },
  { slug: 'rexue', name: '热血少年', icon: 'ri-flashlight-line', count: 892 },
  { slug: 'lianai', name: '恋爱甜宠', icon: 'ri-heart-line', count: 756 },
  { slug: 'qihuan', name: '奇幻冒险', icon: 'ri-magic-line', count: 643 },
  { slug: 'wuxia', name: '武侠江湖', icon: 'ri-sword-line', count: 421 },
  { slug: 'dushi', name: '都市生活', icon: 'ri-building-line', count: 534 },
  { slug: 'xiaoyuan', name: '校园青春', icon: 'ri-school-line', count: 398 },
  { slug: 'quanbu', name: '全部漫画', icon: 'ri-apps-line', count: 5280 },
  { slug: 'paihang', name: '排行榜', icon: 'ri-trophy-line', count: 100 },
];

export const slugToName: Record<string, string> = Object.fromEntries(
  allCategories.map((c) => [c.slug, c.name])
);

export const slugToFilterCategory: Record<string, string> = {
  rexue: '热血',
  lianai: '恋爱',
  qihuan: '奇幻',
  wuxia: '武侠',
  dushi: '都市',
  xiaoyuan: '校园',
};

export const categoryNameToSlug: Record<string, string> = {
  '热血': 'rexue',
  '恋爱': 'lianai',
  '奇幻': 'qihuan',
  '武侠': 'wuxia',
  '都市': 'dushi',
  '校园': 'xiaoyuan',
};

export function getCategoryName(slug: string): string {
  return slugToName[slug] || '全部漫画';
}

export function getCategorySlug(categoryName: string): string {
  return categoryNameToSlug[categoryName] || 'quanbu';
}